<div class="popup-container tlms-popup">
	<header>
		<div class="header" style="display:block">{{heading}} Dummy Route</div>
		<button class="close" style="top:-3px" (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
	</header>
	<ng-container>
		<div style="padding: 16px 24px 16px 24px;">
			<div class="col-12" style="width: 100%;">
				<div class="upload">
					<label class="label">Dummy Route Name
						<span style="color:#ff0000">*</span>
					</label>
					<input type="text" id="dummyRoute" name="dummyRoute" required class="dummy_route"
						[(ngModel)]="dummyRoute" maxlength="6">
				</div>
				<label *ngIf="enableError" class="errormsg"> Please fill in the required fields! </label>
			</div>
		</div>
		<div class="cfooter d-flex justify-content-between align-items-center popup-footer">
			<button (click)="onNoClick()" class="mCancel"> CANCEL
			</button>
			<button class="costpl-submit" style="display: inline" (click)="saveClick()">
				SAVE
			</button>
		</div>
	</ng-container>
</div>